import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { MessageDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/MessageDialog";
import { PageManager } from "@seriously-rad/seriouslyrad-framework-core/Ui/PageManager";

export type EntityCommandCaseClonePropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandCaseCloneProperties = {
    [name in keyof EntityCommandCaseClonePropertyValues]: Property<EntityCommandCaseClonePropertyValues[name]>
};

export interface IEntityCommandCaseClone extends IEntityCommand, EntityCommandCaseCloneProperties
{
}

export class EntityCommandCaseClone extends EntityCommand implements IEntityCommandCaseClone
{
    // #region Static

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandCaseClonePropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Clone",
                entityName: "Case",
                key: "CASE_CLONE",
                permission: PermissionEvaluator.permissionLevels.create,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected messageDialog?: MessageDialog;

    // #endregion

    // #region Constructors

    constructor(propertyValues?: PartialNullable<EntityCommandCaseClonePropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override async _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        await super._executeAsync(entityCommandInformation, value);

        const
            entitySetName = entityCommandInformation.entitySetName.get(),
            record = entityCommandInformation.record.get();

        if (!entitySetName)
            return;

        if (!record || !record.id)
            return;

        await PageManager.instance.navigateAsync(
            "/cases/new",
            null,
            null,
            {
                recordToClone:
                    await
                        ServiceManager.getRequired(WebApiClientService)
                            .createEntityGetRequest(
                                entitySetName,
                                record.id)
                            .executeAsync()
            }
        );
    }

    // #endregion

    // #endregion
}

